(function () {
  var X = window.Xmaso || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    format = format || X.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function fmt(n, dec, thou, decSep) {
      var fixed = (n / 100).toFixed(dec);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? whole + decSep + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.hidden = true; }, 2800);
  }

  /* ---------- announcement ---------- */
  var msgs = $$('.ann-msg');
  if (msgs.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ai = 0, wrap = $('#ann');
    setInterval(function () {
      wrap.style.opacity = 0;
      setTimeout(function () {
        msgs[ai].hidden = true; ai = (ai + 1) % msgs.length; msgs[ai].hidden = false; wrap.style.opacity = 1;
      }, 400);
    }, 4000);
  }

  /* ---------- gallery ---------- */
  var mainImg = $('#mainImg');
  $$('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = b.dataset.src; mainImg.alt = b.dataset.alt || '';
      mainImg.removeAttribute('srcset');
      mainImg.classList.toggle('contain', parseFloat(b.dataset.ratio || '1') < 0.95);
      $$('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  });

  /* ---------- product form ---------- */
  var form = $('#ProductForm');
  var dataEl = $('#ProductJson');
  var pdata = null;
  try { pdata = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { pdata = null; }

  function currentVariant() {
    if (!pdata) return null;
    var input = $('[data-variant-input]');
    var id = input ? Number(input.value) : null;
    for (var i = 0; i < pdata.variants.length; i++) if (pdata.variants[i].id === id) return pdata.variants[i];
    return pdata.variants[0];
  }
  function selectedBundle() {
    var r = $('input[name="bundle"]:checked');
    return r ? { qty: Number(r.value), discount: Number(r.dataset.discount || 0) } : { qty: 1, discount: 0 };
  }
  function refreshPrices() {
    var v = currentVariant(); if (!v) return;
    var compareEach = v.compare > v.price ? v.compare : v.price;
    var b = selectedBundle();
    var line = Math.round(v.price * b.qty * (100 - b.discount) / 100);
    var was = compareEach * b.qty;

    var set = function (sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); };
    set('[data-price-now]', formatMoney(line));
    set('[data-cta-price]', formatMoney(line));
    set('[data-mbar-price]', formatMoney(line));
    $$('[data-price-was]').forEach(function (el) { el.textContent = formatMoney(was); el.hidden = was <= line; });
    $$('[data-price-save]').forEach(function (el) { el.textContent = 'You save ' + formatMoney(was - line); el.hidden = was <= line; });

    $$('.bundle').forEach(function (lab) {
      var r = $('input', lab); var q = Number(r.value), d = Number(r.dataset.discount || 0);
      var l = Math.round(v.price * q * (100 - d) / 100), w = compareEach * q;
      var le = $('[data-line]', lab); if (le) le.textContent = formatMoney(l);
      var we = $('[data-line-was]', lab); if (we) { we.textContent = formatMoney(w); we.hidden = w <= l; }
      var ee = $('[data-each]', lab); if (ee) ee.textContent = formatMoney(Math.round(l / q));
    });

    var qtyInput = $('[data-qty-input]'); if (qtyInput) qtyInput.value = b.qty;
    var btn = $('#addBtn');
    if (btn) {
      btn.disabled = !v.available;
      if (!v.available) btn.textContent = 'Sold out';
      else if (!$('[data-cta-price]', btn)) btn.innerHTML = 'Add to cart · <span data-cta-price>' + formatMoney(line) + '</span>';
    }
    var stock = $('[data-stock]');
    if (stock) stock.innerHTML = v.available ? '<span class="dot"></span>' + (pdata.stockText || 'In stock') : 'Sold out';
  }
  $$('input[name="bundle"]').forEach(function (r) { r.addEventListener('change', refreshPrices); });
  var vs = $('#VariantSelect');
  if (vs) vs.addEventListener('change', function () {
    $('[data-variant-input]').value = vs.value;
    var v = currentVariant();
    if (v && v.img && mainImg) { mainImg.src = v.img; mainImg.removeAttribute('srcset'); mainImg.classList.remove('contain'); }
    try { var u = new URL(location.href); u.searchParams.set('variant', vs.value); history.replaceState(null, '', u); } catch (e) {}
    refreshPrices();
  });
  if (pdata) refreshPrices();

  /* ---------- cart drawer ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim');
  function openCart() { if (!drawer) return; drawer.hidden = false; scrim.hidden = false; var c = $('#closeCart'); if (c) c.focus(); }
  function closeCart() { if (!drawer) return; drawer.hidden = true; scrim.hidden = true; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    var count = $('#count'); if (count) count.textContent = cart.item_count;
    var items = $('#items'); if (!items) return;
    if (!cart.items.length) { items.innerHTML = '<p class="empty">Your cart is empty.</p>'; }
    else {
      items.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<small style="color:var(--ginger);display:block">' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</small>'; }).join('');
        return '<div class="item">' + (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
          '<div><b>' + esc(it.product_title) + '</b>' + variant + disc +
          '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity +
          '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<b>' + formatMoney(it.final_line_price) + '</b></div>';
      }).join('');
    }
    var sub = $('#subtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
  }
  function fetchCart() { return fetch(X.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  if (drawer) {
    $('#items').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-line]'); if (!b) return;
      b.disabled = true;
      fetch(X.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.q)) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Could not update the cart. Please try again.'); });
    });
    $('#closeCart').addEventListener('click', closeCart);
    scrim.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    var opener = $('#openCart');
    if (opener && X.cartType !== 'page') opener.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(renderCart).then(openCart); });
  }

  if (form && X.cartType !== 'page') {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = $$('button[type="submit"][form="ProductForm"], #addBtn');
      btns.forEach(function (b) { b.disabled = true; });
      fetch(X.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); openCart(); })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart.'); })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); refreshPrices(); });
    });
  }

  /* closing CTA buys directly when a product form is on the page */
  $$('[data-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!form) return;
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  /* ---------- sticky mobile buy bar ---------- */
  var mbar = $('#mbar'), add = $('#addBtn');
  if (mbar && add && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0]; mbar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(add);
  }

  /* ---------- mist puffs ---------- */
  $$('.mist-box').forEach(function (box) {
    var img = $('img', box), ch = $$('.chimney', box);
    if (!img || ch.length < 2) return;
    var xs = [parseFloat(box.dataset.c1x || 0.31), parseFloat(box.dataset.c2x || 0.65)], fy = parseFloat(box.dataset.cy || 0.05);
    function place() {
      if (!img.naturalWidth) return;
      var bw = box.clientWidth, bh = box.clientHeight, ih = bw * img.naturalHeight / img.naturalWidth, top = bh - ih;
      ch.forEach(function (c, i) { c.style.left = (xs[i] * bw - 30) + 'px'; c.style.bottom = (bh - (top + fy * ih)) + 'px'; });
    }
    if (img.complete) place(); else img.addEventListener('load', place);
    window.addEventListener('resize', place);
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { location.reload(); });
  }
})();
